



























































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import UserResearchCenter from "@/models/security/userResearchCenter.Model";
import UserService from "@/services/user.service";
import BaseSelectPerson from "@/components/base/baseSelectPerson/baseSelectPerson.vue";
import BaseSelectResearchCenter from "@/components/base/baseSelectResearchCenter/baseSelectResearchCenter.vue";
import UserResearchCenterService from "../../services/UserResearchCenter.service";
@Component({
  components: {
    baseSelectPerson: BaseSelectPerson,
    baseSelectResearchCenter: BaseSelectResearchCenter
  }
})
export default class ResearchCenterCollaboratorAdd extends GenericAdd<
  UserResearchCenter
> {
  active = false;
  researchCenters = [];
  userService: UserService = new UserService();
  userResearchCenterService: UserResearchCenterService = new UserResearchCenterService();
  loading: boolean = false;
  userSelected: any = null;
  colaborators = [];

  constructor() {
    super();
    this.controller = "UserResearchCenter";
    this.model = new UserResearchCenter();
  }

  protected async validate() {
    
    let exist = this.colaborators.some(
      (x: UserResearchCenter) =>
        x.researchCenterId == this.model.researchCenterId &&
        x.userId == this.model.userId
    );

    if (exist) {
      this.$buefy.toast.open({
        message:
          "Este usuario ya es colaborador de este centro de investigación",
        queue: false,
        duration: 4000,
        type: "is-danger",
        position: "is-top-right"
      });
      return;
    }

    try {
      var result = await this.$validator.validateAll();
      if (result) {
        this.add();
        return;
      }
      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }
  protected async add() {
    try {
      this.saving = true;
      let result = await this.repository.create(this.model);
      this.saving = false;
      this.$emit("add", result);
      this.clean();
      this.operationSuccess();

      if (this.exitOnSave) this.confirmedCancel();
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }

  mounted() {
    this.getcenterById();
    this.model.isCollaborator = true;
    this.getUserResearchCenterColaborator();
  }

  get user() {
    return this.$store.state.user;
  }

  public getcenterById() {
    if (this.userService) {
      this.userService.researchCenterByUser(this.user.id).then(center => {
        this.researchCenters = center;
      });
    }
  }
  public getUserResearchCenterColaborator() {
    this.userResearchCenterService
      .getUserResearchCenterColaborator(this.user.id)
      .then(reposnse => {
        this.colaborators = reposnse;
      });
  }
}
